module.exports = __webpack_public_path__ + "static/media/kite.210fdd8d.svg";